import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject } from 'rxjs';
import { ColumnDescription, UserReportFilter } from '../../../models/user-report-filter.model';

@Injectable({
  providedIn: 'root'
})
export class UserReportFilterSliderService {
  public userReportFilterSlider: BehaviorSubject<boolean>;
  public userFilterSidenav: MatSidenav;
  public selectedUserFilter: BehaviorSubject<UserReportFilter>;
  public selectedUserFilterReq: BehaviorSubject<any>;
  public userFilter: BehaviorSubject<UserReportFilter>;

  constructor() {
    this.userReportFilterSlider = new BehaviorSubject(false);
    this.selectedUserFilter = new BehaviorSubject(new UserReportFilter());
    this.selectedUserFilterReq = new BehaviorSubject({});
  }

  activeSlider(reportTypeId: number, mode: number, originalColumns: Array<ColumnDescription>, filter: UserReportFilter) {
    this.userReportFilterSlider.next(true);
    this.selectedUserFilterReq.next({ reportTypeId: reportTypeId, mode: mode, filter: filter, originalColumns: originalColumns });
    this.userFilterSidenav.toggle();
  }

  public setUserFilterSideNav(userFilterSideNavObj: MatSidenav) {
    this.userFilterSidenav = userFilterSideNavObj;
  }

  public userFilterClose() {
    this.userReportFilterSlider.next(false);
    this.userFilterSidenav.close();
  }

  public setData(filter: UserReportFilter) {
    this.selectedUserFilter.next(filter);
  }

  public resetFilter() {
    this.selectedUserFilter.next(null);
  }
}
